<template>
    <v-layout>
      <v-container align-center fill-height v-if="!initSystemFinished">
        <v-layout align-center class="pt-4" column style="height: 200px">
          <v-progress-circular
            :color="'accent'"
            :value="100"
            size="50"
            indeterminate
          ></v-progress-circular>
          <!--<v-btn @click="goTo()">跳转</v-btn>-->
        </v-layout>
      </v-container>
      <l-layout :layout="['xs12']" v-else>
        <v-card flat tile>
          <v-card-title style="height: 80px" class="py-0 pt-0 title">
            <span class="pl-2">车辆预约<span class="error--text" style="font-size: 14px">(*请勿预约出租车)</span></span>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text class="pt-0">
            <v-container class="pt-0"  >
              <v-form ref="reservationForm">
                <v-layout column class="pa-0">
                  <v-select :items="reservationTypeSelect" item-text="name" item-value="value" v-model="reservationType" label="预约类型"
                            prepend-icon="$vuetify.icons.title"></v-select>
                  <v-card v-show="form.vehicles.length!==0">
                    <v-card-title>
                      <h4>车辆列表</h4>
                    </v-card-title>
                    <v-layout column v-for="(v,index) in form.vehicles" :key="index">
                      <v-divider></v-divider>
                      <v-layout>
                        <v-layout column>
                          <v-flex xs10 class="pl-4 pt-3 pb-2">
                            <span>【车辆号牌】{{v.plate}}</span>
                          </v-flex>
                          <v-flex xs10 class="pl-4 pt-0 pb-3">
                            <span>【手机号码】{{v.ownerTel}}</span>
                          </v-flex>
                        </v-layout>
                        <div style="text-align: center" class="pt-3">
                          <v-btn flat color="error" @click="deleteVehicle(index)" :disabled="disabledFlag">删除</v-btn>
                        </div>
                      </v-layout>
                    </v-layout>
                  </v-card>
                  <v-layout justify-center v-if="!addVehicle" column>
                    <v-layout xs12>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="addVehicle=!addVehicle" :disabled="disabledFlag">添加车辆</v-btn>
                    </v-layout>
                  </v-layout>
                  <v-layout column>
                    <v-layout column v-if="addVehicle" class="mt-2">
                      <v-form ref="vehicleForm">
                        <v-flex xs12>
                          <LPlatePicker v-model="form.plate" label="车辆号牌"></LPlatePicker>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            v-model="form.phone"
                            label="手机号码"
                            clearable
                            type="number"
                            prepend-icon="$vuetify.icons.phone"
                            :rules="$rules.phone11()"></v-text-field>
                        </v-flex>
                      </v-form>
                      <v-layout class="ml-4">
                        <v-flex xs6 class="pl-5">
                          <v-btn class="primary" small @click="addVehicleToReservation">确认</v-btn>
                        </v-flex>
                        <v-flex xs6 class="ml-1">
                          <v-btn class="error" @click="addVehicle=!addVehicle;form.plate='';form.phone=''" small>取消</v-btn>
                        </v-flex>
                      </v-layout>
                    </v-layout>
                    <v-layout column>
                      <v-flex xs12>
                        <v-select
                            @focus="showConfigSelect"
                            prepend-icon="$vuetify.icons.parkingLot"
                            ref="configSelect"
                            label="允许通行卡口"
                            v-model="form.config"
                            :items="form.configSelect"
                            :disabled="disabledFlag"
                            item-text="name"
                            chips
                            clearable
                            small-chips
                            multiple
                            :rules="[$rules.requiredS('请选择关口')]"
                        >
                        </v-select>
                      </v-flex>
                      <v-flex xs12>
                        <v-select label="预约进场日期" :items="startDaySelect" v-model="startDay" clearable  :disabled="disabledFlag || !form.config || form.config.length === 0"
                                  :rules="[$rules.requiredS()]" prepend-icon="$vuetify.icons.date"
                                  :hint="(!form.config || form.config.length === 0) ? '请先选择允许通行卡口' : ''" persistent-hint>
                          <template slot="no-data">
                            <v-layout justify-center class="pt-3">
                              <p>暂无可选时间</p>
                            </v-layout>
                          </template>
                        </v-select>
                      </v-flex>
                      <v-flex xs12>
                        <v-select label="预约进场时间" :items="startHourSelect" v-model="startHour"  clearable  :disabled="disabledFlag || !form.config || form.config.length === 0"
                                  :rules="[$rules.requiredS()]" prepend-icon="$vuetify.icons.date"
                                  :hint="(!form.config || form.config.length === 0) ? '请先选择允许通行卡口' : ''" persistent-hint>
                          <template slot="no-data">
                            <v-layout justify-center class="pt-3">
                              <p>暂无可选时间</p>
                            </v-layout>
                          </template>
                        </v-select>
                      </v-flex>
                      <v-flex xs12>
                        <v-select label="预约出场时间" :items="endDateSelect" v-model="endDate"  clearable
                                  :disabled="disabledFlag || isEndTimeLocked || !form.config || form.config.length === 0"
                                  :readonly="isEndTimeLocked"
                                  :rules="[$rules.requiredS()]" prepend-icon="$vuetify.icons.date"
                                  :hint="(isEndTimeLocked ? `根据区域限制，通行时长为 ${activeDuration} 小时` : '') || ((!form.config || form.config.length === 0) ? '请先选择允许通行卡口' : '')" persistent-hint>
                          <template slot="no-data">
                            <v-layout justify-center class="pt-3">
                              <p>暂无可选时间</p>
                            </v-layout>
                          </template>
                        </v-select>
                      </v-flex>
                    </v-layout>
                  </v-layout>
                  <v-layout justify-center class="ml-3">
                    <v-btn class="primary" @click="submit" :disabled="disabledFlag" :loading="loading">提交</v-btn>
                  </v-layout>
                </v-layout>
              </v-form>
            </v-container>
          </v-card-text>
          <v-dialog width="350px" v-model="showConfigDialog" persistent>
            <v-layout column justify-center>
              <v-card>
                <v-list subheader>
                  <v-subheader>通行卡口选择</v-subheader>
                  <v-list-tile v-for="(c,index) in form.configSelect" v-if="form.configSelect.length!==0" @click="changeIsSelect(index)">
                    <v-list-tile-action>
                      <v-icon v-if="!c.isSelect">mdi-checkbox-blank-outline
                      </v-icon>
                      <v-icon v-else color="primary">mdi-checkbox-marked
                      </v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title class="text-xs-left">
                        <p :class="(c.isSelect)?'primary--text':''">{{c.name}}</p>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile v-if="form.configSelect.length===0">
                    <v-list-tile-content >
                      <v-list-tile-title class="text-xs-center">暂未授权</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
                <v-card-actions>
                  <v-layout justify-center>
                    <v-btn  color="primary" @click="configSelectConfirm">确定</v-btn>
                    <v-btn  color="error" @click="showConfigDialog=false">取消</v-btn>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-layout>
          </v-dialog>
        </v-card>
      </l-layout>
    </v-layout>
</template>
<script>
import LPlatePicker from '../../components/LPlatePicker'
import {ID_TYPE_TEXT, ID_TYPE_REVERSE} from '../../consts/reservation'
import {ReservationAuthority, ReservationGroup, PassRule} from '../../object'
import {time} from '../../ladmin/utils/time'
import SelectDatetimeWx from './selectDatetime_wx'
function VisitorVehicle (id = 0, p = '', t = '', n = '', o = '', idt = '', idn = '') {
  return {
    id: id,
    plate: p,
    ownerTel: t,
    ownerName: n,
    ownerOrg: o,
    ownerIDNumber: idn,
    ownerIDType: idt
  }
}

export default {
  name: 'personalReservation_wx',
  components: {
    SelectDatetimeWx,
    LPlatePicker
  },
  data () {
    return {
      testCheck: false,
      showConfigDialog: false,
      form: {
        plate: '',
        phone: '',
        vehicles: [],
        /* name: '',
        org: '',
        idType: '',
        idNum: '',
        idTypeSelect: Object.keys(ID_TYPE_TEXT).map(key => ({text: ID_TYPE_TEXT[key], value: key})), */
        startDatetime: '',
        endDatetime: '',
        configSelect: [],
        config: []
      },
      reservationTypeSelect: [
      ],
      loading: false,
      reservationType: '',
      presetCtrls: [],
      disabledFlag: false,
      addVehicle: true,
      startDay: '',
      startHour: '',
      endDate: '',
      limitAreaConfigs: [],
      activeDuration: null,
      isEndTimeLocked: false,
    }
  },
  computed: {
    reservation () {
      return new ReservationGroup()
    },
    passRule () {
      return new PassRule()
    },
    self () {
      return this.$store.state.login.self
    },
    auth () {
      if (this.reservationType === '') {
        return
      }
      return (this.reservationType === 'person') ? this.$store.state.reservation.personalAuth : this.$store.state.reservation.orgAuth
    },
    maxStartDay () {
      if (this.auth.maxStartDay >= 0) {
        return this.auth.maxStartDay
      }
      return undefined
    },
    /* minStartDay () {
      if (this.auth.minStartDay >= 0) {
        return this.auth.minStartDay
      }
      return undefined
    },
    maxStartDate () {
      if (this.maxStartDay !== undefined) {
        let d = new Date()
        d.setDate(d.getDate() + this.maxStartDay)
        return d
      }
      return undefined
    },
    minStartDate () {
      if (this.minStartDay !== undefined) {
        let d = new Date()
        d.setDate(d.getDate() + this.minStartDay)
        return d
      }
      return undefined
    },
    durationError () {
      return (s, e) => {
        return !s || !e || s <= e || '不能大于结束时间'
      }
    },*/
    maxDurationDay () {
      if (this.auth.maxDurationDay >= 0) {
        return this.auth.maxDurationDay
      }
      return undefined
    },
    maxDurationDate () {
      if (this.maxDurationDay === undefined || !this.form.startDatetime) {
        return
      }
      let [year, month, day] = this.startDate.split('-')
      if (year && month && day) {
        // console.log(this.startDate, Number(year), Number(month) - 1, Number(day), this.maxDurationDay)
        let d = new Date(Number(year), Number(month) - 1, Number(day))
        d.setDate(d.getDate() + this.maxDurationDay - 1)
        return this.$L.time.stringify(d, this.$L.time.D)
      }
      return undefined
    },
    startDate () {
      let group = /^\d{4}-\d\d-\d\d/i.exec(this.form.startDatetime)
      if (group) {
        let date = group[0]
        return date
      }
      else {
        return undefined
      }
    },
    parkingLotSelects () {
      let selects = []
      if (this.items instanceof Array) {
        selects = this.items
      }
      else if (this.itemsP instanceof Array) {
        selects = this.itemsP
      }
      else if (this.$store.state.parkingLot.parkingLotList instanceof Array) {
        selects = this.$store.state.parkingLot.parkingLotList.slice()
      }
      if (selects.length === 0) {
        selects.push({header: '没有可选停车场区'})
      }
      return selects
    },
    controllers () {
      let cs = []
      if (this.items instanceof Array) {
        cs = Array.prototype.concat.apply([], this.items.map(t => t.controllers))
      }
      else if (this.itemsC instanceof Array) {
        cs = this.itemsC
      }
      else if (this.$store.state.parkingLot.controllerList instanceof Array) {
        cs = this.$store.state.parkingLot.controllerList.slice()
      }
      return cs
    },
    startDaySelect () {
      let startDate = new Date()
      let maxDate = new Date()
      maxDate.setDate(maxDate.getDate() + this.maxStartDay)
      let times = []
      times.push(time.stringify(startDate).substr(0, 10))
      while (startDate < maxDate) {
        startDate.setDate(startDate.getDate() + 1)
        times.push(time.stringify(startDate).substr(0, 10))
      }
      return times
    },
    startHourSelect () {
      let startDate = new Date()
      let times = []
      if (this.startDay === time.stringify(startDate).substr(0, 10)) {
        let stHour = startDate.getHours()
        for (let i = stHour; i <= 23; i++) {
          if (i < 10) {
            let item = '0' + i + '点'
            times.push(item)
          }
          else {
            times.push(i + '点')
          }
        }
      }
      else {
        for (let i = 0; i <= 23; i++) {
          if (i < 10) {
            let item = '0' + i + '点'
            times.push(item)
          }
          else {
            times.push(i + '点')
          }
        }
      }
      return times
    },
    endDateSelect () {
      if (this.startDay === '' || this.startHour === '') {
        return []
      }
      else {
        let times = []
        let startHour = parseInt(this.startHour.substring(0, 2))
        let st = startHour + 1
        
        // 确保出场时间最多到24点，且不能早于或等于进场时间
        for (let i = st; i <= 24; i++) {
          if (i < 10) {
            times.push('0' + i + '点')
          }
          else if (i === 24) {
            times.push('24点')
          }
          else {
            times.push(i + '点')
          }
        }
        return times
      }
    },
    initSystemFinished () {
      return this.$store.state.login.initSystemFinished
    }
  },
  created () {
    this.init()
  },
  mounted () {

  },
  methods: {
    async init () {
      let res = await this.$store.dispatch('login/initSystemInfo').catch(e => {
        this.$L.error(e.message)
      })
      this.dealPermission()
      this.reservation.applicant = this.self
      this.reservation.owner = this.self
      let config = this.$store.state.reservation.globalConfig || {}
      this.reservation.audioPromptIn = config.audioPromptIn || ''
      this.reservation.ledPromptIn = config.ledPromptIn || ''
      this.reservation.audioPromptOut = config.audioPromptOut || ''
      this.reservation.ledPromptOut = config.ledPromptOut || ''

    },
    showConfigSelect () {
      this.$refs.configSelect.blur()
      this.form.configSelect.forEach((c) => {
        c.isSelect = false
      })

      for (let i = 0; i < this.form.config.length; i++) {
        for (let j = 0; j < this.form.configSelect.length; j++) {
          if (this.form.config[i].name === this.form.configSelect[j].name) {
            this.form.configSelect[j].isSelect = true
          }
        }
      }
      this.showConfigDialog = true
    },
    changeIsSelect (index) {
      this.form.configSelect[index].isSelect = !this.form.configSelect[index].isSelect
      this.form.configSelect = [...this.form.configSelect]
    },
    configSelectConfirm () {
      this.form.config = []
      for (let i = 0; i < this.form.configSelect.length; i++) {
        if (this.form.configSelect[i].isSelect) {
          this.form.config.push(this.form.configSelect[i])
        }
      }
      this.showConfigDialog = false
    },
    async dealPermission () {
      // console.log('开始处理权限查询')
      let permission = await this.$store.dispatch('login/getPermission')
      if (permission.wechat.personalReservation_wx !== undefined) {
        this.reservationTypeSelect.push({name: '个人预约', value: 'person'})
      }
      if (permission.wechat.orgReservation_wx !== undefined) {
        this.reservationTypeSelect.push({name: '单位预约', value: 'org'})
      }
      if (this.reservationTypeSelect.length === 0) {
        this.$router.push({name: 'AccessDeny'})
      }
      else {
        this.reservationType = this.reservationTypeSelect[0].value
        this.getReservationConfig(this.reservationType)
      }
    },
    async getReservationConfig (type) {
      let typeMap = {
        person: {type: 'order_object', name: '个人预约'},
        org: {type: 'order_group', name: '单位预约'}
      }
      let res = await this.$store.dispatch('reservationConfig/getReservationConfig', typeMap[type].type)
      // console.log(res.data.data)
      if (res.data.status === 1) {
        let object = new ReservationAuthority({
          name: typeMap[type].name,
          maxVehicleAmount: 1000,
          maxStartDay: res.data.data.maxAdvDays,
          minStartDay: 0,
          maxDurationDay: res.data.data.maxDurDays,
          presetCtrls: res.data.data.presetCtrls,
          limitAreaConfigs: res.data.data.limitAreaConfigs || []
        })
        this.form.configSelect = res.data.data.presetCtrls
        this.form.configSelect.sort(function (a,b) {
          return a.name<b.name
        })
        this.dealPresetCtrls(this.form.configSelect)
        this.form.configSelect.forEach((c) => {
          c.isSelect = false
        })
        console.log(this.form.configSelect)

        // 从同一接口数据中提取 limitAreaConfigs
        if (res.data.data.limitAreaConfigs && Array.isArray(res.data.data.limitAreaConfigs)) {
          this.limitAreaConfigs = res.data.data.limitAreaConfigs;
        } else {
          this.limitAreaConfigs = [];
        }

        if (type === 'person') {
          this.$store.commit('reservation/setPersonalAuth', object)
        }
        else {
          this.$store.commit('reservation/setOrgAuth', object)
        }
      }
      else {
        this.form.configSelect = []
        this.$L.alert('error', {message: '查询预约配置失败，原因：' + res.data.msg})
      }
    },
    checkForm () {
      if (this.$refs.reservationForm.validate()) {
        if (this.form.config.length === 0) {
          this.$L.alert('error', {message: '请选择通行关口'})
          return false
        }
        else if (this.form.vehicles.length === 0) {
          this.$L.alert('error', {message: '请添加车辆'})
          return false
        }
        return true
      }
      else {
        this.$L.alert('error', {message: '表单数据不合法'})
        return false
      }
    },
    dealPresetCtrls (data) {
      for (let k = 0; k < data.length; k++) {
        var name = data[k].name
        var controllers = []
        var items = []
        for (let i = 0; i < data[k].controllerIds.length; i++) {
          for (let j = 0; j < this.controllers.length; j++) {
            if (this.controllers[j].id === data[k].controllerIds[i]) {
              controllers.push(this.controllers[j])
            }
          }
        }
        for (let i = 0; i < this.parkingLotSelects.length; i++) {
          var item = {
            name: this.parkingLotSelects[i].name,
            id: this.parkingLotSelects[i].id,
            controllers: []
          }
          for (let j = 0; j < controllers.length; j++) {
            if (controllers[j].parkingLot.id === this.parkingLotSelects[i].id) {
              item.controllers.push(controllers[j])
            }
          }
          if (item.controllers.length !== 0) {
            items.push(item)
          }
        }
        var config = {
          name: name,
          controllers: controllers,
          item: items
        }
        this.presetCtrls.push(config)
      }
      // console.log(this.presetCtrls)
    },
    addVehicleToReservation () {
      if (this.$refs.vehicleForm.validate()) {
        let vehicle = {
          id: '',
          plate: this.form.plate,
          ownerTel: this.form.phone,
          ownerName: '',
          ownerOrg: '',
          ownerIDNumber: '',
          ownerIDType: ''
        }
        for (let i = 0; i < this.form.vehicles.length; i++) {
          if (this.form.vehicles[i].plate === vehicle.plate) {
            this.$L.alert('error', {message: '请勿添加重复车辆'})
            return false
          }
        }
        this.form.vehicles.push(vehicle)
        this.addVehicle = false
        this.form.plate = ''
        this.form.phone = ''
        return true
      }
      else {
        this.$L.alert('error', {message: '格式错误'})
      }
    },
    deleteVehicle (index) {
      // console.log(index)
      this.form.vehicles.splice(index, 1)
      // console.log(this.form.vehicles)
    },
    async submit () {
      if (this.form.plate !== '' && this.form.phone !== '') {
        if (!this.addVehicleToReservation()) {
          return
        }
      }
      if (this.checkForm()) {
        this.reservation.vehicles = this.form.vehicles
        this.passRule.startDatetime = this.startDay + ' ' + this.startHour.substring(0, 2) + ':00:00'
        this.passRule.endDatetime = (this.endDate + '' === '24点') ? this.startDay + ' ' + '23:59:59' : this.startDay + ' ' + this.endDate.substring(0, 2) + ':00:00'
        this.reservation.rules.push(this.passRule)
        console.log(this.reservation)
        try {
          this.loading = true
          let res = await this.$store.dispatch('reservation/submitReservation', {
            reservationGroup: this.reservation,
            type: this.reservationType
          })
          this.loading = false
          this.$L.alert('success', {message: '预约成功'})
          this.disabledFlag = true
        }
        catch (e) {
          console.log(e)
          this.$L.alert('error', {title: '预约时发生错误', message: e.message, raw: e})
        }
        finally {
          this.loading = false
        }
      }
    },
    checkAreaLimitAndSetEndTime () {
      this.isEndTimeLocked = false
      this.activeDuration = null
      if (!this.form.config || this.form.config.length === 0 || !this.startDay || !this.startHour || this.limitAreaConfigs.length === 0) {
        return
      }

      // 根据预约类型选择不同的匹配逻辑
      const isPersonalReservation = this.reservationType === 'person';
      
      for (const selectedConfig of this.form.config) {
        for (const limitConfig of this.limitAreaConfigs) {
          let isMatched = false;
          
          if (isPersonalReservation) {
            // 个人预约：部分匹配逻辑
            if (limitConfig.controllerIds && Array.isArray(limitConfig.controllerIds)) {
              const selectedControllerIds = [];
              
              // 从选中的配置中提取controllerIds
              for (const preset of this.presetCtrls) {
                if (preset.name === selectedConfig.name) {
                  selectedControllerIds.push(...preset.controllers.map(c => c.id));
                  break;
                }
              }
              
              // 检查是否有交集
              isMatched = limitConfig.controllerIds.some(id => selectedControllerIds.includes(id));
            }
          } else {
            // 单位预约：完全匹配逻辑
            if (limitConfig.controllerIds && Array.isArray(limitConfig.controllerIds)) {
              const selectedControllerIds = [];
              
              // 从选中的配置中提取controllerIds
              for (const preset of this.presetCtrls) {
                if (preset.name === selectedConfig.name) {
                  selectedControllerIds.push(...preset.controllers.map(c => c.id));
                  break;
                }
              }
              
              // 检查是否完全包含
              isMatched = limitConfig.controllerIds.every(id => selectedControllerIds.includes(id));
            }
          }
          
          if (isMatched && limitConfig.duration) {
            this.activeDuration = limitConfig.duration;
            this.isEndTimeLocked = true;
            this.calculateAndSetEndTime();
            return; // 找到第一个匹配就退出
          }
        }
      }
    },
    calculateAndSetEndTime () {
      if (!this.isEndTimeLocked || !this.activeDuration || !this.startDay || !this.startHour) {
        return
      }
      try {
        const startDateTimeStr = `${this.startDay} ${this.startHour.substring(0, 2)}:00:00`
        const startDateTime = new Date(startDateTimeStr.replace(/-/g, '/'))

        if (isNaN(startDateTime.getTime())) {
          console.error('无效的开始日期时间:', startDateTimeStr)
          return
        }

        const endDateTime = new Date(startDateTime.getTime() + this.activeDuration * 60 * 60 * 1000)

        let endHour = endDateTime.getHours()
        // 修复跨月日期检测bug：正确检测是否跨天
        const startDateString = startDateTime.toDateString()
        const endDateString = endDateTime.toDateString()
        
        if (startDateString !== endDateString) {
          // 跨天了，设置为24点
          this.endDate = '24点'
        } else {
          if (endHour === 0 && endDateTime.getMinutes() === 0 && endDateTime.getSeconds() === 0 && endDateTime.getTime() > startDateTime.getTime()) {
            this.endDate = '24点'
          } else {
            this.endDate = (endHour < 10 ? '0' + endHour : endHour) + '点'
          }
        }

        console.log(`Start: ${startDateTimeStr}, Duration: ${this.activeDuration}h, Calculated End: ${this.endDate}`)

        this.$nextTick(() => {
          this.$refs.reservationForm.validate()
        })
      } catch (e) {
        console.error('计算结束时间时出错:', e)
        this.endDate = ''
      }
    },
  },
  watch: {
    reservationType () {
      this.getReservationConfig(this.reservationType)
    },
    'form.config': {
      handler(newVal, oldVal) {
        this.passRule.gateways = []
        for (let i = 0; i < this.form.config.length; i++) {
          for (let j = 0; j < this.presetCtrls.length; j++) {
            if (this.form.config[i].name === this.presetCtrls[j].name) {
              for (let k = 0; k < this.presetCtrls[j].item.length; k++) {
                var obj = {
                  name: this.presetCtrls[j].item[k].name,
                  id: this.presetCtrls[j].item[k].id,
                  controllers: this.presetCtrls[j].item[k].controllers
                }
                console.log(obj)
                this.passRule.gateways = [...this.passRule.gateways, obj]
              }
            }
          }
        }
        console.log(this.passRule)
        this.checkAreaLimitAndSetEndTime()
        if ((!newVal || newVal.length === 0) && oldVal && oldVal.length > 0) {
          this.isEndTimeLocked = false
          this.activeDuration = null
        }
      },
      deep: true
    },
    initSystemFinished () {
      if (this.initSystemFinished) {
        this.dealPermission()

      }
    },
    startDay() {
      this.checkAreaLimitAndSetEndTime()
      if (!this.isEndTimeLocked) {
        this.endDate = ''
      }
    },
    startHour() {
      this.checkAreaLimitAndSetEndTime()
      if (!this.isEndTimeLocked) {
        this.endDate = ''
      }
    },
    'form.startDatetime' (val, oldVal) {
      /* let time = this.$L.time
      if (val && !oldVal) {
        let d = time.parse(val)
        let now = new Date()
        if (time.stringify(d, time.D) === time.stringify(now, time.D) &&
          time.stringify(d, time.DT) !== time.stringify(now, time.DT)) {
          this.form.startDatetime = time.stringify(now, time.DT)
        }
      } */
      /* let endDateTime = new Date(this.form.startDatetime)
      if (endDateTime.getHours() < 18 || (endDateTime.getHours() === 18 && endDateTime.getMinutes() === 0)) {
        endDateTime.setDate(endDateTime.getDate())
        endDateTime.setHours(endDateTime.getHours() + 4)
        this.form.endDatetime = time.stringify(endDateTime)
      } */
    },
  }
}
</script>
